document.addEventListener("DOMContentLoaded", function () {
  // دالة تهيئة السوايبر داخل التبويب
  function initializeSwiper(swiperContainer) {
    const settings = JSON.parse(swiperContainer.dataset.settings || "{}");

    // حساب عدد السلايدات
    const slideCount = swiperContainer.querySelectorAll(".swiper-slide").length;
    const loopEnabled = slideCount > (settings.desktop || 3);

    new Swiper(swiperContainer, {
      loop: loopEnabled,
      speed: settings.speed || 600,
      slidesPerView: settings.desktop || 3,
      spaceBetween: settings.spaceBetween || 30,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: {
        nextEl: swiperContainer.querySelector(".swiper-button-next"),
        prevEl: swiperContainer.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: swiperContainer.querySelector(".swiper-pagination"),
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: settings.mobile || 1
        },
        768: {
          slidesPerView: settings.tablet || 2
        },
        1024: {
          slidesPerView: settings.desktop || 3
        }
      }
    });

    swiperContainer.classList.add("swiper-initialized");
  }

  // تهيئة السوايبر للعناصر الظاهرة عند التحميل
  document.querySelectorAll(".rb-course-swiper").forEach((swiperContainer) => {
    if (!swiperContainer.classList.contains("swiper-initialized")) {
      initializeSwiper(swiperContainer);
    }
  });

  // عند الضغط على التبويب
  document.querySelectorAll(".rb-tab-title").forEach((tab) => {
    tab.addEventListener("click", () => {
      // إزالة الحالة النشطة
      document
        .querySelectorAll(".rb-tab-title")
        .forEach((t) => t.classList.remove("active"));
      document
        .querySelectorAll(".rb-tab-content")
        .forEach((c) => c.classList.remove("active"));

      // تفعيل التبويب الحالي
      tab.classList.add("active");
      const tabId = tab.getAttribute("data-tab");
      const targetContent = document.getElementById(tabId);
      if (targetContent) {
        targetContent.classList.add("active");

        const swiperContainer =
          targetContent.querySelector(".rb-course-swiper");
        if (
          swiperContainer &&
          !swiperContainer.classList.contains("swiper-initialized")
        ) {
          requestAnimationFrame(() => {
            initializeSwiper(swiperContainer);
          });
        }
      }
    });
  });
});
